/*
 * @Descripttion: 
 * @version: 
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-07-01 13:33:41
 * @LastEditors: K
 * @LastEditTime: 2022-08-24 13:52:09
 */
import { Col, Row } from "antd";
import React, { ReactElement, useRef, useState } from "react";
import { NavBar } from "../../../compnents/nav/NavBar";
import { RoundTabBar, TabPane } from "../../../compnents/widgets/RoundTabBar";
import { Patient } from "../../../models/patient";
import { useQuery } from "../../../utils/HttpUtils";
import { FollowUpTab } from "../../followUp/followUpTab";
import {
  PatientDetailPanelRef,
} from "../PatientDetailPanel";
import { PatientPayments } from "./PatientPayments";
import { PatientReports } from "./PatientReports";
import { PatientTreatmentHistory } from "./PatientTreatmentHistory";
import { ChainPatientDetailPanel } from "../ChainPatientDetailPanel";
import { ChainPatientDetailBasic } from "./ChainPatientDetailBasic";
import { ChainPatientPayments } from "./ChainPatientPayments";
import { ChainPatientTreatmentHistory } from "./ChainPatientTreatmentHistory";

export const ChainPatientDetail = (): ReactElement => {
  const query = useQuery();

  const patientId = query.get("patientId") as string;

  const tenantId = query.get("tenantId") as string;

  const ref = useRef<PatientDetailPanelRef>(null);

  const [selectedTab, setSelectedTab] = useState("基本信息");

  const [patient, setPatient] = useState<Patient | undefined>();

  return (
    <Col
      style={{
        height: "calc(100% - 20px)",
        margin: "10px 20px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <NavBar
        where={["患者管理", selectedTab]}
        backtrace={{
          name: "患者管理",
          path: "/statistics/outpatient",
        }}
      />

      <Row wrap={false} style={{ flex: 1, marginTop: 10, overflow: "hidden" }}>
        <Col
          style={{
            height: "100%",
            overflow: "auto",
          }}
        >
          <ChainPatientDetailPanel
            ref={ref}
            style={{ width: 242 }}
            editable={false}
            patientId={patientId}
            tenantId={tenantId}
            onChange={(p) => setPatient(p)}
          />
        </Col>
        <RoundTabBar
          style={{ marginLeft: 20, flex: 1 }}
          activeKey={selectedTab}
          onChange={(k) => setSelectedTab(k)}
        >
          <TabPane key="基本信息" tab="基本信息">
            <ChainPatientDetailBasic
              patient={patient}
              onSave={() => {
                ref.current?.reload();
              }}
            />
          </TabPane>
          <TabPane key="病历信息" tab="病历信息">
            <ChainPatientTreatmentHistory patientId={patientId} tenantId={tenantId} />
          </TabPane>
          <TabPane key="消费信息" tab="消费信息">
            <ChainPatientPayments patientId={patientId} />
          </TabPane>
          <TabPane key="随访信息" tab="随访信息">
            <FollowUpTab patientId={patientId} chainFlag={true} tenantId={tenantId}/>
          </TabPane>
        </RoundTabBar>
      </Row>
    </Col>
  );
};
